module.exports = __webpack_public_path__ + "static/media/spinSounds_3.1a15cd36.mp3";